import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useState } from "react";
import {
  Badge,
  Box,
  Button,
  Checkbox,
  IconButton,
  TableFooter,
  TablePagination,
  Tooltip,
  useTheme,
} from "@mui/material";
import OptionMenu from "./OptionMenu";
import moment from "moment/moment";
import {
  DoneOutline,
  History,
  KeyboardArrowDown,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  KeyboardArrowUp,
  Print,
  Sell,
  Send,
  Undo,
  UnfoldMore,
  Visibility,
} from "@mui/icons-material";
import useTimer from "../../customHooks/useTimer";
import { useMemo } from "react";
import PropTypes from "prop-types";
import ButtonDropDown from "../ButtonDropDown";
import ButtonDropDown1 from "../ButtonDropDown1";
import ButtonDropDownFulfilled from "../ButtonDropDownFulfilled";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: "#11508e",
    color: "#fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "#111",
    // color: "rgb(255, 255, 255)",
    // mixBlendMode: "difference",
    // "& .MuiCheckbox-root":{
    //   color:"#333"
    // },
  },

  "& svg": {
    position: "relative",
    cursor: "pointer",
  },
  "&:last-child": {
    mixBlendMode: "unset",

    "& svg": {
      color: "#111",
      //   color: "rgb(255, 255, 255)",
      // mixBlendMode: "difference"
    },
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  color: "#111",
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const ActionBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "45px",
  [theme.breakpoints.down("md")]: {
    gap: "20px",
  },
}));

function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;
  const theme = useTheme();

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };


  return (
    <div style={{ flexShrink: "0" }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 1}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage)}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function TableComponentView(props) {

  const handleClickPrint = (val, row) => {
    props.handlePrint(val, row);
  };

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              {props.columns.map((col, index) =>
                props.sort ? (
                  index === 0 ? (
                    <StyledTableCell
                      key={col.id}
                      onClick={() => props.handleSort(col.id)}
                    >
                      {props.currentColumn === col.id ? (
                        <span style={{ fontWeight: "700" }}>{col.name}</span>
                      ) : (
                        col.name
                      )}
                      {props.currentColumn === col.id ? (
                        props.direction === "asc" ? (
                          <KeyboardArrowUp fontSize="small" />
                        ) : (
                          <KeyboardArrowDown fontSize="small" />
                        )
                      ) : (
                        <UnfoldMore fontSize="small" />
                      )}
                    </StyledTableCell>
                  ) : (
                    <StyledTableCell
                      key={col.id}
                      align="right"
                      onClick={() => props.handleSort(col.id)}
                    >
                      {props.currentColumn === col.id ? (
                        <span style={{ fontWeight: "700" }}>{col.name}</span>
                      ) : (
                        col.name
                      )}
                      {props.currentColumn === col.id ? (
                        props.direction === "asc" ? (
                          <KeyboardArrowUp fontSize="small" />
                        ) : (
                          <KeyboardArrowDown fontSize="small" />
                        )
                      ) : (
                        <UnfoldMore fontSize="small" />
                      )}
                    </StyledTableCell>
                  )
                ) : index === 0 ? (
                  <StyledTableCell key={col.id}>{col.name}</StyledTableCell>
                ) : (
                  <StyledTableCell key={col.id} align="right">
                    {col.name}
                  </StyledTableCell>
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody style={{ position: "relative", width: "100%" }}>
            {props.rows.length ? (
              props.rows.map((row) => {

                var created = moment(new Date(row.created_at));
                var ausDate = new Date()
                  .toLocaleString("en-US", {
                    timeZone: "Australia/Melbourne",
                  })
                  .toString();
                var currentDate = moment(new Date(ausDate));
                var diff = moment
                  .duration(currentDate.diff(created))
                  .asMinutes();

                return (
                  <StyledTableRow
                    key={row.id}
                    style={{
                      background:
                        props.print ? ((diff > 5 && diff < 7 || row.order_info?.orderSequence === 3)
                          ? "#FFD580"
                          : (diff > 7 && diff < 8 || row.order_info?.orderSequence === 4)
                            ? "#ffcccb"
                            : (row.order_info?.orderSequence === 1)
                              ? "#E6E6FA"
                              : (row.order_info?.orderSequence === 2)
                                ? "#FC8EAC"
                                : (row.order_info?.readyToFulfill === 1)
                                  ? "#F5F5F5"
                                  : "#ff9693"
                        ) : (diff < 5 || (row.readyToFulfill === 1 && row.payments?.length > 0)
                          ? "#9FE2BF"
                          : (diff > 5 && diff < 7 || row.orderSequence === 3)
                            ? "#FFD580"
                            : (diff > 7 && diff < 8 || row.orderSequence === 4)
                              ? "#ffcccb"
                              : (row.orderSequence === 1)
                                ? "#E6E6FA"
                                : (row.orderSequence === 2)
                                  ? "#FC8EAC"
                                  : (row.readyToFulfill === 1)
                                    ? "#F5F5F5"
                                    : "#ff9693"
                        )
                    }}
                  >
                    {props.columns.map((col, index) =>
                      col.id === "image" ? (
                        index === 0 ? (
                          <StyledTableCell
                            key={col.id}
                            component="th"
                            scope="row"
                          >
                            <img
                              src={
                                typeof row.image === "string"
                                  ? row.image
                                  : row.image[0]
                              }
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "contain",
                              }}
                              alt={row.firstname}
                            />
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell key={col.id} align="right">
                            <img
                              src={row.image}
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "contain",
                              }}
                              alt={row.firstname}
                            />
                          </StyledTableCell>
                        )
                      ) : col.id === "check" ? (
                        <StyledTableCell key={col.id} align="right">
                          {props.openBackdrop &&
                            (props.checkedValues.includes(row.id)) ? (
                            <h3 style={{ fontWeight: "700" }}>
                              {props.backdropNumber}...
                            </h3>
                          ) : (
                            <Checkbox
                              checked={props.checkedValues.includes(row.id)}
                              onChange={(e) => props.handleCheck(e, row)}

                            />
                          )}
                        </StyledTableCell>
                      ) : (
                        <StyledTableCell key={col.id} align="right">
                          {col.id === "actions" && (
                            <ActionBox>
                              {props.handlePrint && (
                                row.orderSequence ? (
                                  <ButtonDropDownFulfilled
                                    handleClickPrint={handleClickPrint}
                                    row={row}
                                  />
                                ) : (
                                  <ButtonDropDown
                                    handleClickPrint={handleClickPrint}
                                    row={row}
                                  />
                                )
                              )}
                              {props.handleMarkPick && (
                                <Tooltip title="Mark Order as Collected">
                                  <DoneOutline
                                    onClick={() => props.handleMarkPick(row)}
                                  />
                                </Tooltip>
                              )}
                              {props.handleMarkDialogueOrder && (
                                <Tooltip title="Mark Order as Collected">
                                  <DoneOutline
                                    onClick={() => props.handleMarkDialogueOrder(row)}
                                  />
                                </Tooltip>
                              )}
                              {props.handleUnpickOrder && (
                                <Tooltip title="Unpick Order">
                                  <Undo
                                    onClick={() => props.handleUnpickOrder(row)}
                                  />
                                </Tooltip>
                              )}
                              {props.handlePickupOrder && (
                                <Tooltip title="Pickup Order">
                                  <Send
                                    onClick={() => props.handlePickupOrder(row)}
                                  />
                                </Tooltip>
                              )}

                              {props.handleViewHistoryDetails && (
                                <Tooltip title="View Query History">
                                  <Badge badgeContent={row.picked_history?.length} color="primary">
                                    <History
                                      onClick={() => props.handleViewHistoryDetails(row)}
                                    />
                                  </Badge>
                                </Tooltip>
                              )}
                              {props.handleResendInvoice && (
                                <Tooltip title="Resend Tax Invoice">
                                  <Send
                                    onClick={() => props.handleResendInvoice(row)}
                                  />
                                </Tooltip>
                              )}

                              <Tooltip title="View Details">
                                <Visibility
                                  onClick={() => props.handleViewDetails(row, props.fulfill, props.print)}
                                />
                              </Tooltip>
                            </ActionBox>
                          )}

                          {(col.id === "created_at" || col.id === "added" || col.id === "lastModified" || col.id === "pickedDatetime" || col.id === "RFCD" || col.id === "invoicedDateTime" || col.id === "invoicedDate")
                            ? row[col.id] === null ? null : row[col.id] === "0000-00-00 00:00:00"
                              ? moment(row["added"]).format(
                                "ddd, MMM Do YYYY, h:mm:ss a"
                              )
                              : moment(row[col.id]).format(
                                "ddd, MMM Do YYYY, h:mm:ss a"
                              )
                            : col.id === "total"
                              ? "$" + row[col.id]
                              : col.id === "total_lines2.0"
                                ? parseInt(row.total_lines)
                                : col.id === "isInvoiced"
                                  ? row?.order_info.isInvoiced === 1 ? "Invoiced" : "Not Invoiced"
                                  : col.id === "salesid2.0"
                                    ? row?.order_info.salesid
                                    : col.id === "dlvmode2.0"
                                      ? row?.order_info.dlvmode
                                      : col.id === "salesname2.0"
                                        ? row?.order_info.salesname
                                        : col.id === "sales_type2.0"
                                          ? row?.order_info.sales_type
                                          : col.id === "salespoolid2.0"
                                            ? row?.order_info.salespoolid
                                            : col.id === "fulfill"
                                              ? `${row.fulfilled_items + " of " + row.total_lines}`
                                              : col.id === "fulfill_percentage"
                                                ? `${Math.min(((row.fulfilled_items / row.total_lines) * 100).toFixed(2), 100)}%`
                                                : col.id === "items"
                                                  ? row.sales_details?.length
                                                  : col.id === "school_info"
                                                    ? row.school_info?.SchoolName
                                                    : col.id === "item"
                                                      ? row.sales_lines?.length
                                                      : row[col.id]}
                        </StyledTableCell>
                      )
                    )}
                  </StyledTableRow>
                );
              })
            ) : (
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  height: "50px",
                  position: "absolute",
                }}
              >
                <p>No Order Found!</p>
              </Box>
            )}
          </TableBody>

          {props.footer !== false && (
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[20, 50, 70, 100]}
                  rowsPerPage={props.rowsPerPage}
                  page={props.page}
                  count={props.total && props.total}
                  SelectProps={{
                    native: true,
                  }}
                  labelDisplayedRows={() =>
                    `${props.from !== null ? props.from : "0"} - ${props.to !== null ? props.to : "0"
                    } to ${props.total}`
                  }
                  onPageChange={props.handleChangePage}
                  onRowsPerPageChange={props.handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>
    </Paper >
  );
}
